<template>
  <div ref="cell" class="grid-view__cell grid-field-qr-code__cell">
    <div class="grid-field-qr-code">
      <QRCodeCanvas :value="resolvedSourceValue" :size="28" />
    </div>
  </div>
</template>

<script>
import sourceFieldReferenceField from '@baserow/modules/database/mixins/sourceFieldReferenceField'
import QRCodeCanvas from '@baserow/modules/database/components/field/QRCodeCanvas'

export default {
  name: 'FunctionalGridViewFieldQRCode',
  components: { QRCodeCanvas },
  // Same reasoning as FunctionalGridViewFieldBarcode: no gridField mixin,
  // this variant is never selected/edited.
  mixins: [sourceFieldReferenceField],
  props: {
    row: { type: Object, required: true },
    field: { type: Object, required: true },
    value: { type: null, default: null },
  },
}
</script>
